module.exports = __webpack_public_path__ + "static/media/language.4da891f8.svg";